import i18n from "i18next";
import { atom } from "jotai";
import { focusAtom } from "jotai/optics";
import { atomFamily } from "jotai/utils";

import { VEHICLE_CONDITION_TRANSLATION_KEYS } from "pages/VehicleCondition/constants";
import { VehicleConditionQuestions } from "pages/VehicleCondition/types";

import { clientConfigAtom } from "atoms/clientConfig";
import { createDerivedSessionAtom } from "atoms/utils/createDerivedSessionAtom";
import { createPersistedAtom } from "atoms/utils/createPersistedAtom";

import { mileageAtom } from "./mileage";

const sessionQuestionsAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<VehicleConditionQuestions>(`vehicleQuestions-${sessionId}`, {})
);

export const vehicleConditionQuestionsAtom = createDerivedSessionAtom<VehicleConditionQuestions>(sessionQuestionsAtom);

export const getQuestionAtom = atomFamily((property: keyof VehicleConditionQuestions) =>
  focusAtom(vehicleConditionQuestionsAtom, (optic) => optic.prop(property))
);

export const vehicleConditionAtom = atom((get) => ({
  mileage: get(mileageAtom),
  ...get(vehicleConditionQuestionsAtom),
}));

export const formattedVehicleConditionAtom = atom((get) => {
  const distanceUnit: string = i18n.t("vehicle_condition.mileage.unit");

  const formattedVehicleQuestions = Object.entries(get(vehicleConditionQuestionsAtom)).map(([key, value]) => {
    const question = key as keyof VehicleConditionQuestions;
    const answer = value ? i18n.t("global.yes") : i18n.t("global.no");
    return { label: VEHICLE_CONDITION_TRANSLATION_KEYS[question], value: answer };
  });

  return get(clientConfigAtom).vehicleCondition.showMileage
    ? [
        {
          label: VEHICLE_CONDITION_TRANSLATION_KEYS["mileage"],
          value: `${get(mileageAtom)} ${distanceUnit}`,
        },
        ...formattedVehicleQuestions,
      ]
    : [...formattedVehicleQuestions];
});
